import React from 'react'
import styled from 'styled-components'
import 'bootstrap/dist/css/bootstrap.min.css'
import imagenes from '../assest/imagenes.js'




const Home = () => {
  return (
    <Homme>

  {/*Primera parte*/}

   <div className='imagenhome'>
    
    <img className='imag0' src={imagenes.img0}></img>
    <img className='imgMaquillaje' src='https://tahecosmetics.com/trends/wp-content/uploads/2022/06/historia-del-maquillaje.jpg'></img>
    
    </div> 

 {/*Segunda Parte*/}

 <div className="makeup" id='makeup'>
    <p className='makeupp'>
    Make Up
    </p>
    </div>

  {/*Tercera Parte*/}

  <div class="card-group">
    <div class="card-body">
      <h5 class="card-title">Make Up with eyelashes</h5>
      <p class="card-text">Maquillaje Rostro Completo + Pestañas.</p>
      <p class="card-text"><small class="text-body-secondary">$6500</small></p>
    </div>
    <div class="card-body">
      <h5 class="card-title">Make Up without eyelashes</h5>
      <p class="card-text">Maquillaje Rostro Completo /sin Pestañas.</p>
      <p class="card-text"><small class="text-body-secondary">$6000</small></p>
    </div>
    </div>




  {/*Cuarta Parte*/}

  <div className="galeria" id='galeria'>
    <p>
    Galería de Fotos
    </p>
    </div>

  {/*Quinta parte

  
  {/*Sexta Parte*/}

  <section className='conjuntodeimagenes'>
   <img className='imag4' src={imagenes.img4}></img>
   <img className='imag2' src={imagenes.img2}></img>
   <img className='imag3' src={imagenes.img3}></img>
   <img className='imag7' src={imagenes.img7}></img>
   <img className='imag8' src={imagenes.img8}></img>
   <img className='imag1' src={imagenes.img1}></img>
   <img className='imag9' src={imagenes.img9}></img>
   <img className='imag5' src={imagenes.img5}></img>
   <img className='imag10' src={imagenes.img10}></img>
   <img className='imag6' src={imagenes.img6}></img>
   <img className='imag11' src={imagenes.img11}></img>
  </section>

  {/*Septima Parte*/}

  <div className="SobreAriadna" id='SobreAriadna'>
    <p>
    Sobre Ariadna
    </p>
    </div>
  
  <section className='ari'>
  <div className='ariadnaescudero'>
    <img className='ariadna' src={imagenes.img12}></img>
    <p>Hola, Soy Ariadna Escudero, Maquilladora Profesional. <br></br>
      Estudié en el instituto Emma Wellness. Actualmente me dedico al maquillaje social.<br></br>
      Te invito a que me sigas en las redes sociales.
      
    </p>
    
  </div>
  </section>

  {/*Novena Parte*/}


  <div className="contenedor" id='contactos'>
    <div className='imagendelogo'>
      <img className='imagz' src={imagenes.img0}></img>
      </div>
    <div className="text-center">
    <h1>Enviame un mensaje, <br></br>seguí mis redes sociales!</h1>
      </div>
    <div className="header-right">
      <h1>Contactos</h1>
      <a href='#'><i className="bi bi-instagram"></i><i>ariadna.eventmakeupp</i></a>
      <a href='#'><i className="bi bi-whatsapp"></i><i>+54(9)26163339734</i></a>
      </div>
  </div>

  
    </Homme>

  
  )

}

   

export default Home;

const Homme = styled.div`


.imagenhome {
  text-align: left;

  .imag0 {
    position: relative;
    left: 8rem;
    width: 20%;
    z-index: -3;
    box-shadow: 2px 1px 10px black;
  }

  @media (max-width: 576px) {
   .imag0 {
    position: relative;
    left: 35px;
   } 
  }

  .imgMaquillaje {
    position: relative;
    z-index: -4;
    width: 80%;
    box-shadow: 0px -5px 10px #ddb7ab;

  }

}

p {
  font-size: 3rem;
}

.frase {
    width:  100%;
    padding: 5rem;
    text-align: center;
    background-color: #efd9d1;
}


.makeup {
  position: relative;
  width:  100%;
  padding: 5rem;
  text-align: center;
  z-index: -5;
  background-color: #999b84;
}

.card-group {
  padding: 10%;
}

.card-body{
  position: relative;
  z-index: -5;
  border: 1px solid black;
  text-align: center;
  padding: 10%;
  margin: 0 auto;
  .card-title{
    font-size: 2rem;
  }
  .card-text{
    font-size: 1rem;
  }
}

.galeria {
  width:  100%;
  padding: 5rem;
  text-align: center;
  background-color: #999b84;
}

.carousel-inner{
  width: 400px;
  text-align: center;
}

.conjuntodeimagenes {
  display: flex;
  width: 100%;
  height: 10%;
}


.conjuntodeimagenes img {
  width: 0px;
  flex-grow: 1;
  object-fit: cover;
  opacity: .8;
  transition: .5s ease;
}

@media (max-width: 576px) {
  section img {
    width: 100%;
    height: 300px;
  }
}

.conjuntodeimagenes img:hover {
  cursor: crosshair;
  width: 300px;
  opacity: 1;
  filter: constrast(120%);
}

.SobreAriadna {
  width:  100%;
  padding: 5rem;
  text-align: center;
  background-color: #999b84;
}




@media (max-width: 578px) {
  .ariadnaescudero {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .ariadna {
    margin-top: 20px;
    margin-botton: 10px;
    width: 200px;
    box-shadow: 0px 5px 10px black;
  }

  .ariadnaescudero p {
    font-size: 30px;
    background-color: #ddb7ab;
    margin-top: 20px;
  }
}

@media (min-width: 578px) {
  .ari {
    display: flex;
    align-items: center;
  }
  
  .ariadnaescudero {
    display: flex;
    align-items: center;
    text-align: center;
  }
  
  .ariadnaescudero p {
    background-color: #ddb7ab;
    padding: 100px;
    margin: 100px;
  }

  .ariadna {
    margin: 100px;
    width: 500px;
    box-shadow: 0px 5px 10px black;
  }
}

.contenedor {
  width: 100%;
  heigth: 200px;
  margin-top: 20px;
  background-color: #999b84;
}



@media (max-width: 576px) {

  .contenedor {
    width: 100%;
    heidth: 20%;
  }

  .imagendelogo .imagz {
    display: none;
   }
  .text-center {
    display: none;
  }
  .header-right {
    padding: 50px 0;
    text-align: center;
    h1 {
      margin: 0px;
      font-size: 40px;
      text-align: center;
    }
  
    a {
      display: block;
      text-align: center;
      font-size 20px;
      margin: 10px;
      } 
    i {
      padding: 10px;
      }
  }
}

@media (min-width: 578px) {
  .contenedor {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
  }
  
  .imagendelogo {
    flex: 1;
    margin-right: 20px;
  }

  .imagz {
    width: 300px;
    margin: 50px;
    box-shadow: 0px 5px 10px black;
  }
  
  .text-center {
    flex: 1;
  }
  
  .header-right {
    flex: 1;
  }

  a {
    display: block;
    text-align: center;
    font-size 20px;
    margin: 10px;
    } 
  i {
    padding: 10px;
    }
}



`